import { gql } from '../__generated__/gql';

export const homeRecsQuery = gql(`query getHomeRecs {
    collections(cExperienceId: "zillowWebHomePageCollections") {
        collections {
            __typename
            contentType
            recs {
                id {
                    type
                    value
                }
                recsTags {
                    type
                    value
                }
                heroImage {
                    id
                    defaultLink
                    mediumSizeLink
                    highResolutionLink
                }
            }
            name
            caption
            contentType
            link {
                displayText
                url
            }
            trackingTags {
                type
                value
            }
            propertyDetails {
                address {
                    city
                    state
                    streetAddress
                    zipcode
                }
                attributionInfo {
                    brokerName
                    brokerPhoneNumber
                    mlsId
                    mlsName
                    agentName
                    agentPhoneNumber
                    providerLogo
                }
                bedrooms
                bathrooms
                building {
                    buildingName
                }
                buildingId
                country
                currency
                hdpUrl
                newConstructionType
                price
                pslHomeType
                pslMarketingStatus
                pslProviderCategory
                pslRawHomeStatus
                videoId
                isZillowOwned
                zestimate
                pslPublicForeclosureStage
                listingStatusChangeDate
                livingAreaValue
                isRecentStatusChange
                isPremierBuilder
                isNonOwnerOccupied
                isSavedByCurrentSignedInUser
                photos {
                    url
                    width
                    height
                }
                zpid
                listingMetadata {
                    isAdsRestricted
                }
            }
        }
        trackingTags {
            type,
            value
        }
    }
}`);

export const ompQuery =
    gql(`query getOmpData($placements: [String], $isCarouselAdsRestricted: Boolean, $surfaceId: String, $platform: String) {
        onsiteMessage(placementNames: $placements, placementData: { isCarouselAdsRestricted: $isCarouselAdsRestricted }, surfaceId: $surfaceId, platform: $platform ) {
            messages {
                    skipDisplayReason
                    shouldDisplay
                    isGlobalHoldout
                    isPlacementHoldout
                    placementName
                    testPhase
                    bucket
                    placementId
                    passThrottle
                    lastModified
                    eventId
                    decisionContext
                    selectedTreatment {
                        id
                        name
                        component
                        status
                        renderingProps
                        lastModified
                    }
                    qualifiedTreatments {
                        id
                        name
                        status
                        lastModified
                    }
                }
            }
}`);

export const yourTeamBCQuery =
    gql(`query getYourTeamBC($refId: String, $refType: BridgeParticipantReferenceType) {
        bridgeContainer(refId: $refId, refType: $refType) {
            moves {
                id
                team {
                    agents {
                        zuid
                        paAgent {
                            name
                            businessName
                            email
                            phone
                            photoUrl
                            hasPremierAgent
                            profile {
                                officeCity
                                officeState
                                profileUrl
                                ratingAverage
                                ratingCount
                            }
                        }
                    }
                }
            }
        }
        viewer {
            firstName
        }
    }
`);
